import { abortIfNotPermitted } from '../../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "stock-receive" */ '@js/franchise_component/franchise-inventory/stock-receive/stock-receive-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_stock_receive',
                next,
            );
        },
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "stock-receive-create" */ '@js/franchise_component/franchise-inventory/stock-receive/stock-receive-create.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_inventory_stock_receive',
                next,
            );
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "stock-receive-create" */ '@js/franchise_component/franchise-inventory/stock-receive/stock-receive-edit.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_stock_receive',
                next,
            );
        },
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/franchise-inventory/stock-receive.js